<template>
  <Layout :title="meta.title">
    <template v-if="canRender">
      <section class="card-section">
        <!-- commission or indicated tab -->
        <template v-if="promoter_id">
          <base-tab
            v-model="currentStep"
            :arr="tabs"
            :has-pre-counter="false"
            version="v2"
          />
        </template>

        <!-- search field and cards info -->
        <div class="statement">
          <div class="search">
            <base-calendar
              v-model="form.period"
              @input="setFiltersToStorage"
            >
              Buscar por período
            </base-calendar>

            <button
              class="button"
              @click="loadStartingData"
            >
              Buscar
            </button>
          </div>
          <section class="card-list">
            <!-- Cards -->
            <section
              v-for="(card, index) in cards"
              :key="index"
              class="is-card"
              :class="card.class"
            >
              <p class="card__title">
                {{ card.title }}
              </p>
              <div class="card__content">
                <p class="card__content__amount font-xl is-bold">
                  <template v-if="card.showAmount">
                    {{ card.amount | money }}
                  </template>
                  <template v-else>
                    {{ card.amount }}
                  </template>
                </p>
                <button
                  v-if="list.payments[0]?.value !== 0"
                  class="button"
                  @click="toggleValuesRequest(card.showAmountVariable)"
                >
                  <template v-if="card.showAmount">
                    <i class="fas fa-eye-slash" /> Esconder
                  </template>
                  <template v-else>
                    <i class="fas fa-eye" /> Exibir
                  </template>
                </button>
              </div>
              <span v-if="!!card.updated_at">
                <ClockSVG />
                Atualizado em {{ formattedDate(card.updated_at) }}
              </span>
            </section>
          </section>
        </div>
      </section>

      <!-- Tabela de pagamentos -->
      <section class="card-section">
        <!-- list table -->
        <div class="payments">
          <div class="header">
            <h2 class="is-bold font-lg">
              Pagamentos
            </h2>
            <div class="actions">
              <template v-if="details.show">
                <button
                  class="button"
                  @click="loadStartingData"
                >
                  <CloseIconSVG />
                  Fechar
                </button>

                <button
                  v-if="promoter_id"
                  class="button is-success"
                  :disabled="dataIsEmpty"
                  @click="exportReport"
                >
                  <ExportIconSVG />
                  Exportar CSV
                </button>
              </template>
              <template v-else>
                <button
                  v-if="isCommissionManager"
                  class="button is-success"
                  @click="modal.details = true"
                >
                  Dados de emissão
                </button>
              </template>
            </div>
          </div>

          <div class="content-view">
            <!-- empty state -->
            <template v-if="dataIsEmpty">
              <div class="empty-state has-text-centered">
                <IconEmptyState />
                <p class="is-bold">
                  Não encontramos nenhum resultado para essa solicitação.
                </p>
                <p>
                  Certifique-se que os pagamentos foram realizados dentro do período vigente.
                </p>
              </div>
            </template>

            <!-- content -->
            <template v-else>
              <table class="table">
                <thead>
                  <template v-if="details.show">
                    <tr>
                      <th class="font-sm is-semi-bold">
                        N. CCB
                      </th>
                      <th class="font-sm is-semi-bold">
                        Documento
                      </th>
                      <th class="font-sm is-semi-bold">
                        Nome
                      </th>
                      <th class="font-sm is-semi-bold">
                        Valor
                      </th>
                      <th class="font-sm is-semi-bold">
                        Comissão
                      </th>
                      <th class="font-sm is-semi-bold">
                        Comissão
                      </th>
                      <th class="font-sm is-semi-bold">
                        Tipo
                      </th>
                      <th class="font-sm is-semi-bold">
                        Responsável
                      </th>
                      <th class="font-sm is-semi-bold">
                        Produto
                      </th>
                      <th class="font-sm is-semi-bold">
                        Tabela
                      </th>
                      <th class="font-sm is-semi-bold">
                        Desembolsado em
                      </th>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <th
                        v-if="!promoter_id"
                        class="font-sm is-semi-bold is-centered"
                      >
                        Qt. promotora
                      </th>
                      <th class="font-sm is-semi-bold">
                        Crédito
                      </th>
                      <th class="font-sm is-semi-bold">
                        Débito
                      </th>
                      <th class="font-sm is-semi-bold">
                        Saldo
                      </th>
                      <th class="font-sm is-semi-bold">
                        Criado em
                      </th>
                      <th class="font-sm is-semi-bold is-centered">
                        Ações
                      </th>
                    </tr>
                  </template>
                </thead>

                <tbody>
                  <tr
                    v-for="(item, index) in data_table"
                    :key="index"
                  >
                    <!-- payment details -->
                    <template v-if="details.show">
                      <!-- Proposta -->
                      <td class="font-sm is-semi-bold">
                        <button
                          :key="item.proposal_id"
                          class="button is-link"
                          @click="openProposals(item)"
                        >
                          {{ item.external_proposal_number }}
                        </button>
                      </td>

                      <!-- Documento -->
                      <td class="font-sm is-semi-bold">
                        <span>{{ item.document }}</span>
                      </td>

                      <!-- Nome -->
                      <td class="font-sm is-semi-bold">
                        <span>{{ item.name }}</span>
                      </td>

                      <!-- Valor -->
                      <td class="font-sm is-semi-bold">
                        <span>{{ item[item.calculation_basis] | money }}</span>
                      </td>

                      <!-- Comissão (R$)-->
                      <td class="font-sm is-semi-bold">
                        <span>{{ item.commission_amount | money }}</span>
                      </td>

                      <!-- Comissão (%) -->
                      <td class="font-sm is-semi-bold">
                        <span>
                          {{ percent({
                            commission: item.commission_amount,
                            value: item[item.calculation_basis],
                          }) }}%
                          {{
                            item.calculation_basis === 'amount'
                              ? 'da emissão'
                              : item.calculation_basis === 'net_amount'
                                ? 'do liberado'
                                : 'error'
                          }}
                        </span>
                      </td>

                      <!-- Tipo -->
                      <td class="font-sm is-semi-bold">
                        <span>{{ item.type }}</span>
                      </td>

                      <!-- Responsável -->
                      <td
                        class="has-tooltip-arrow"
                        :data-tooltip="item.responsible_email"
                      >
                        <span>{{ item.responsible_name }}</span>
                      </td>

                      <!-- Produto -->
                      <td class="font-sm is-semi-bold">
                        <span>{{ item.product_name }}</span>
                      </td>

                      <!-- Tabela -->
                      <td class="font-sm is-semi-bold">
                        <span>{{ item.rate_name }}</span>
                      </td>

                      <!-- Liberado em -->
                      <td v-if="details.show">
                        <span>{{ formattedDate(item.loaned_at) }}</span>
                      </td>
                    </template>

                    <!-- payments data -->
                    <template v-else>
                      <!-- Crédito -->
                      <td
                        v-if="!promoter_id"
                        class="is-centered"
                      >
                        {{ item.promoters }}
                      </td>
                      <td class="font-sm is-semi-bold">
                        <span>{{ item.credit | money }}</span>
                      </td>

                      <!-- Débito -->
                      <td
                        class="font-sm is-semi-bold"
                        :data-tooltip="item.obs"
                      >
                        <span>{{ item.debit | money }}</span>
                      </td>

                      <!-- Saldo -->
                      <td class="font-sm is-semi-bold">
                        <span>{{ (item.credit - item.debit) | money }}</span>
                      </td>

                      <!-- Criado em -->
                      <td class="font-sm is-semi-bold">
                        <span>{{ formattedDate(item.created_at) }}</span>
                      </td>

                      <!-- Ações -->
                      <td class="is-centered">
                        <template v-if="promoter_id">
                          <div>
                            <button
                              class="button"
                              @click="getCommissionByProposal(item.id)"
                            >
                              Ver detalhes
                            </button>
                            <template v-if="isCommissionManager">
                              <button
                                class="button"
                                @click="downloadReceipt({ id: item.external_key })"
                              >
                                Baixar comprovante
                              </button>
                            </template>
                          </div>
                        </template>

                        <!-- this is only visible when isCommissionManager -->
                        <template v-else>
                          <button
                            class="button"
                            @click="loadDetails(item.created_at)"
                          >
                            Ver mais
                          </button>
                        </template>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>

          <div v-if="!dataIsEmpty && !details.show">
            <ThePagination
              :data="pagination.financial.data"
              :storage-key="pagination.financial.filterKey"
              @paginate="paginate(pagination.financial.filterKey)"
            />
          </div>
        </div>
      </section>

      <!-- Status da Proposta :: FGTS -->
      <ModalProposalStatus
        v-if="
          modal.status
            && isSupplierQiTech
            && stateProposal.product_name === 'FGTS'
        "
        refresh-proposal-data
        @close="closeModal('status')"
        @receipt="($event) => {
          receiptData = $event;
          modal.status = false;
          modal.receipt = true;
        }"
      />
      <ModalProposalStatusBMP
        v-if="modal.status && isSupplierBMP"
        refresh-proposal-data
        @close="closeModal('status')"
        @receipt="($event) => {
          receiptData = $event;
          modal.status = false;
          modal.receipt = true;
        }"
      />
      <ModalProposalStatusBMS
        v-if="modal.status && isSupplierBMS"
        refresh-proposal-data
        @close="closeModal('status')"
        @receipt="($event) => {
          receiptData = $event;
          modal.status = false;
          modal.receipt = true;
        }"
      />
      <ModalProposalStatusCartos
        v-if="modal.status && isSupplierCartos"
        refresh-proposal-data
        @close="closeModal('status')"
        @receipt="($event) => {
          receiptData = $event;
          modal.status = false;
          modal.receipt = true;
        }"
      />

      <!-- Recibo da Proposta :: FGTS -->
      <ModalProposalStatusReceipt
        v-if="modal.receipt && isSupplierQiTech"
        :receipt-data="receiptData"
        @close="closeModal('receipt')"
        @back="($event) => {
          closeModal('receipt');
          modal.status = true;
        }"
      />
      <ModalProposalStatusReceiptBMP
        v-if="modal.receipt && isSupplierBMP"
        :receipt-data="receiptData"
        @close="closeModal('receipt')"
        @back="($event) => {
          closeModal('receipt');
          modal.status = true;
        }"
      />
      <ModalProposalStatusReceiptCartos
        v-if="modal.receipt && isSupplierCartos"
        :receipt-data="receiptData"
        @close="closeModal('receipt')"
        @back="($event) => {
          closeModal('receipt');
          modal.status = true;
        }"
      />

      <!-- Status da Proposta :: INSS -->
      <ModalProposalStatusINSS
        v-if="modal.status && isSupplierQiTech && stateProposal.product_name === 'INSS'"
        refresh-proposal-data
        @close="closeModal('status')"
        @receipt="($event) => {
          receiptData = $event;
          modal.status = false;
          modal.receipt = true;
        }"
      />

      <ModalProposalStatusWorkerCredit
        v-if="modal.status && isSupplierQiTech && stateProposal.product_name === 'CLT'"
        @close="closeModal('status')"
      />

      <!-- Modals only for Commission -->
      <template v-if="isCommissionManager">
        <!-- modal 'Dados de emissão' -->
        <ModalCommissionDetails
          v-if="modal.details"
          :promoter="promoter_id"
          @close="modal.details = false"
        />

        <!-- modal 'Detalhamento por Promotora' -->
        <BaseSimpleModal
          v-if="modal.showPromoterModal"
          :width="'90%'"
          has-close-button
          @close="modal.showPromoterModal = false"
        >
          <template #title>
            <div class="modal-header">
              <h2 class="is-bold font-lg">
                Detalhamento por Promotora
              </h2>
              <button
                class="button"
                @click="getDetailedCommissionPaymentMasterReport(detailed_table_date, true)"
              >
                <ExportIconSVG />
                Exportar CSV
              </button>
            </div>
          </template>
          <template #body>
            <table class="table">
              <thead>
                <tr>
                  <th class="font-sm is-semi-bold">
                    Promotora
                  </th>
                  <th class="font-sm is-semi-bold">
                    Crédito
                  </th>
                  <th class="font-sm is-semi-bold">
                    Débito
                  </th>
                  <th class="font-sm is-semi-bold">
                    Saldo
                  </th>
                  <th class="font-sm is-semi-bold">
                    Criado em
                  </th>
                  <th class="font-sm is-semi-bold is-centered">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item) in detailed_table"
                  :key="item.promoter_id"
                >
                  <td class="font-sm is-semi-bold">
                    {{ item.name }}
                  </td>
                  <td class="font-sm is-semi-bold">
                    {{ item.credit | money }}
                  </td>
                  <td class="font-sm is-semi-bold">
                    {{ item.debit | money }}
                  </td>
                  <td class="font-sm is-semi-bold">
                    {{ item.credit - item.debit | money }}
                  </td>
                  <td class="font-sm is-semi-bold">
                    {{ formattedDate(item.created_at) }}
                  </td>
                  <td class="is-centered">
                    <button
                      class="button"
                      @click="goToDetailedPromoter(item.promoter_id)"
                    >
                      Ver detalhes
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <ThePagination
              :data="pagination['promoters-payment'].data"
              :storage-key="pagination['promoters-payment'].filterKey"
              @paginate="paginate(pagination['promoters-payment'].filterKey)"
            />
          </template>
          <template #actions>
            <div class="buttons ml-auto">
              <button
                class="button is-success"
                @click="modal.showPromoterModal = false"
              >
                Voltar
              </button>
            </div>
          </template>
        </BaseSimpleModal>
      </template>
    </template>
  </Layout>
</template>

<script>
/** Core */
import { mapState, mapActions } from 'vuex';

import config from '@/data/config';

/** Utils */
import seo from '@/utils/seo';

export default {
  name: 'FinancialView',
  components: {
    Layout: () => import('@/layouts/Layout.vue'),
    BaseCalendar: () => import('@/components/BaseCalendar.vue'),
    BaseSimpleModal: () => import('@/components/BaseSimpleModal.vue'),
    BaseTab: () => import('@/components/BaseTab.vue'),
    ThePagination: () => import('@/components/ThePagination.vue'),

    ModalProposalStatus: () => import('@/components/ModalProposalStatus.vue'),
    ModalProposalStatusBMP: () => import('@/components/ModalProposalStatusBMP.vue'),
    ModalProposalStatusINSS: () => import('@/components/ModalProposalStatusINSS.vue'),
    ModalProposalStatusWorkerCredit: () => import('@/components/ModalProposalStatusWorkerCredit.vue'),
    ModalProposalStatusBMS: () => import('@/components/ModalProposalStatusBMS.vue'),

    ModalProposalStatusReceipt: () => import('@/components/ModalProposalStatusReceipt.vue'),
    ModalProposalStatusReceiptBMP: () => import('@/components/ModalProposalStatusReceiptBMP.vue'),

    ModalCommissionDetails: () => import('@/components/ModalCommissionDetails.vue'),
    // Icons
    ClockSVG: () => import('@/assets/icons/Clock.vue'),
    CloseIconSVG: () => import('@/assets/icons/CloseIcon.vue'),
    ExportIconSVG: () => import('@/assets/icons/ExportIcon.vue'),
    IconEmptyState: () => import('@/assets/icons/EmptyState.vue'),
  },
  beforeRouteLeave({ name }, from, next) {
    if (!name.includes('promoters-commission')) {
      this.setProposalData({});
      this.destroyFiltersToStorage([
        'financial',
        'promoters-payment',
        'commission',
        'indicated',
      ]);
    }

    next();
  },
  data: () => ({
    meta: {
      title: 'Financeiro',
    },
    data_table: [],
    detailed_table: [],
    detailed_table_date: '',
    form: {
      period: [],
    },
    details: {
      show: false,
    },
    pagination: {
      financial: {
        data: {},
        filters: {},
        filterKey: 'financial',
      },
      'promoters-payment': {
        data: {},
        filters: {},
        filterKey: 'promoters-payment',
      },
    },
    modal: {
      showPromoterModal: false,
      details: false,
      status: false,
      receipt: false,
    },
    currentID: null,
    list: {
      payments: [],
    },
    message: {
      error: '',
      timeout: null,
    },
    receiptData: false,
    showReceived: false,
    showToBeReceived: false,
    canRender: false,
    tabs: [
      { title: 'Comissões' },
      { title: 'Indicadas' },
    ],
  }),
  computed: {
    ...mapState({
      user: (state) => state.user.userInfo,
      stateProposal: (state) => state.proposal.proposal,
    }),
    dataIsArray() {
      return Array.isArray(this.data_table);
    },
    dataHasContent() {
      return this.dataIsArray && this.data_table.length > 0;
    },
    dataIsEmpty() {
      return !this.dataIsArray || !this.dataHasContent;
    },
    promoter_id() {
      return this.$route.params.id ?? this.user.promoter_id ?? null;
    },
    isSupplierQiTech() {
      return this.stateProposal.supplier_id === config.SUPPLIER_ID_QITECH;
    },
    isSupplierBMP() {
      return this.stateProposal.supplier_id === config.SUPPLIER_ID_BMP;
    },
    isSupplierBMS() {
      return this.stateProposal.supplier_id === config.SUPPLIER_ID_BMS;
    },
    isSupplierCartos() {
      return this.stateProposal.supplier_id === config.SUPPLIER_ID_CARTOS;
    },
    isSupplierCelcoin() {
      return this.stateProposal.supplier_id === config.SUPPLIER_ID_CELCOIN;
    },
    isCommissionManager() {
      return this.currentStep === 0;
    },
    isIndicatedManager() {
      return this.currentStep === 1;
    },
    cards() {
      return [
        {
          name: 'received',
          title: 'Recebido',
          class: 'is-success',
          amount: this.showReceived ? this.list?.payments[0]?.value : 'R$ ••••••',
          updated_at: this.list?.payments[0]?.updated_at,
          showAmountVariable: 'showReceived',
          showAmount: this.showReceived,
        },
        {
          name: 'toBeReceived',
          title: 'À receber',
          class: 'is-info',
          amount: this.showToBeReceived ? this.list?.payments[1]?.value : 'R$ ••••••',
          updated_at: this.list?.payments[1]?.updated_at,
          showAmountVariable: 'showToBeReceived',
          showAmount: this.showToBeReceived,
        },
      ];
    },
  },
  watch: {
    // changes route based on tab index
    currentStep() {
      // this 'IF' is never going to happens
      // it's here just in case
      if (!this.promoter_id) return;

      // validate current tab and change route accordingly
      const routeID = this.$route.params.id;
      let name;

      // reset pagination
      this.destroyFiltersToStorage([
        'financial',
        'promoters-payment',
      ]);

      if (this.isCommissionManager) {
        // set commission route
        name = routeID
          ? 'promoters-commission-details'
          : 'promoters-commission';
      }

      if (this.isIndicatedManager) {
        // set indicated route
        name = routeID
          ? 'promoters-commission-indicated-details'
          : 'promoters-commission-indicated';
      }

      // dispatch route change
      this.$router.push({
        name,
        params: { ...this.$route.params },
        query: { ...this.$route.query },
      });
    },
  },
  methods: {
    // utils
    ...mapActions({
      setProposalData: 'proposal/SET_PROPOSAL_DATA',
    }),

    // handlers
    handlerError(err) {
      let message = err?.response?.data?.error?.message
        || (err?.error?.response?.data?.error?.message
        || err?.error?.data?.message
        || err?.message
        || err);

      if (err?.response?.data?.error?.errors) {
        const errors = Object.values(err?.response?.data?.error?.errors);

        message = message.concat(`<br> - ${errors.map((error) => error).join('<br> - ')}`);
      }

      this.$set(this.message, 'error', message);
    },
    formattedDate(date) {
      return new Date(date).toLocaleDateString('pt-br', {
        second: ('2-digit'),
        minute: ('2-digit'),
        hour: ('2-digit'),
        timeZone: 'America/Sao_Paulo',
      });
    },
    percent({ commission, value }) {
      return ((commission / value) * 100).toFixed(2);
    },
    async setFiltersToStorage() {
      let dataStorage = await JSON.parse(sessionStorage.getItem(this.storageKey));

      if (dataStorage?.page) delete dataStorage.page;

      dataStorage = {
      // ... what was already on with
        ...dataStorage,

        // current filters
        begin_date: this.form.period[0]?.split('/').reverse().join('-'),
        end_date: this.form.period[1]?.split('/').reverse().join('-'),
      };

      // return only valid values
      dataStorage = Object
        .keys(dataStorage)
        .reduce((obj, key) => {
          if (dataStorage[key]) obj[key] = dataStorage[key];
          return obj;
        }, {});

      sessionStorage.setItem(this.storageKey, JSON.stringify(dataStorage));
    },
    destroyFiltersToStorage(args) {
      const destroyStorage = (key) => sessionStorage.removeItem(key);

      if (Array.isArray(args)) {
        for (const key of args) {
          destroyStorage(key);
        }
      } else {
        destroyStorage(args);
      }
    },
    openProposals(data) {
      this.setProposalData(data);
      this.modal.status = true;
    },
    closeModal(key) {
      this.modal[key] = false;
    },
    async updatePeriod() {
      const formattedDate = (date) => date.split('-').reverse().join('/');

      const dataStorage = await JSON.parse(sessionStorage.getItem(this.storageKey));

      if (dataStorage?.begin_date && dataStorage?.end_date) {
        this.form.period = [
          formattedDate(dataStorage.begin_date),
          formattedDate(dataStorage.end_date),
        ];
      }
    },
    handleExportRequest({ data, name }) {
      const blob = new Blob([`\ufeff${data}`], { type: 'text/csv;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute(
        'download',
        `${this.currentID ? 'promotoras-' : ''}${name}.csv`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // handlers :: api
    async toggleValuesRequest(toggledValue) {
      if (!this[toggledValue] && this.list.payments.length === 0) {
        await this.getCommissionPaymentReport();
      }

      this[toggledValue] = !this[toggledValue];
    },

    // api
    async paginate(target) {
      this.pagination[target].filters = this.getFiltersFromStorage({
        target,
        raw: true,
      });
      await this.loadStartingData();
    },
  },
  metaInfo() {
    return seo.meta(this.meta);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_textVariables.scss';
@import '@/assets/scss/src/_buttonsVariables.scss';

.modal-header {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
}

.modal-content__actions {
  button {
    flex-grow: 1;
  }
}
.card-section {
  box-shadow: 0px 1px 1px 1px #0A0A0A1A;
  padding: 24px;
  border-radius: 4px;
  margin: 24px 0;
  background-color: #FFF;

  .actions {
    button {
      margin: 2px 0 2px 16px;
    }
  }
}

.statement {

  .search {
    display: flex;
    justify-content: space-between;
    gap: 32px;
    margin-bottom: 2rem;

    .calendar {
      flex-grow: 1;
    }

    .button {
      align-self: flex-end;
      min-height: 42px;
    }
  }

  .card-list {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    overflow: auto;

    .is-card {
      flex-basis: 50%;
      min-width: 300px;
      padding: 32px;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .card__title{
        flex-basis: 100%;
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .card__content {
        width: 100%;
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: space-between;
      }

      // span {
      //   flex-basis: 100%;
      //   margin-top: 16px;
      //   color: map.get($stone-types, "500");
      // }

      &.is-info {
        border: 1px solid $slate-200;
        background-color: $slate-50;

        .is-bold {
          color: $blue-700;
        }
      }
      &.is-success {
        border: 1px solid $slate-200;
        background-color: $green-50;

        .is-bold {
          color: $green-600;
        }
      }
      &.is-hold {
        border: 1px solid map-get($stone-types, '200');
        background-color: map-get($stone-types, '50');
      }
    }
  }
}

.payments {
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
  }
}

.content-view {
  overflow: auto;
  max-height: 550px;
}

.empty-state {
  color: $neutral-grey-70;
  p {
    text-align: center;
  }
}
.table {
  border: 1px solid map.get($stone-types, "200");
  table-layout: fixed;
  display: block;

  thead {
    position: sticky;
    top: 0;
    z-index: 1;

    background-color: $gray-50;
  }
  tbody {
    tr:nth-child(even) td{
      background-color: $gray-50;
    }
  }
  tr {
    border: none;
    display: table-row;

    th, td {
      vertical-align: middle;
      color: map.get($stone-types, "500");
      width: 25%;
      border: none;
      white-space: nowrap;

      &.is-centered {
        text-align: center;
      }
    }

    th {
      border-bottom: 1px solid map.get($stone-types, "200");
      text-transform: uppercase;
      letter-spacing: 0.05rem;
      text-align: left;
      padding: 10px 16px;
    }

    td {
      padding: 18px 16px;
      color: map.get($stone-types, "500");

      div {
        display: flex;
        gap: 8px;
      }
      button {
        max-height: 30px;
      }
    }

    .table-status, .table-action {
      margin-top: 0;
      text-align: center;

      button {
        padding: 7px 11px;
        width: 100px;
      }
    }
  }
}
.options {
  display: flex;
  gap: 12px;
}

.card {
  box-shadow: 0 1px 1px 1px rgba(10, 10, 10, 0.1);
}

.custom-label {
  display: flex;
  align-items: flex-end;

  color: $color-secondary;

  &::before {
    content: '';

    margin: {
      right: 10px;
      bottom: 5px;
    }

    display: block;
    width: 4px;
    height: 1em;
    background-color: $color-primary;
  }

  .featured {
    margin-left: 10px;

    font-size: 1.125em;
    color: $color-primary;
  }
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 2rem;
}

.commission-view {
  display: grid;
  grid-template-rows:
    minmax(var(--info-height), auto)
    calc(100vh - (var(--header-height) + var(--info-height) + var(--footer-height)))
    var(--footer-height)
  ;

  &__content {
    overflow-y: auto;

    .table {
      border-collapse: initial;
      overflow-x: auto;

      th,
      td {
        white-space: nowrap;
      }

      thead {
        th {
          padding: 0.5em;
        }
      }

      tbody {
        tr {
          &:nth-child(2n) {
            background-color: $color-primary-350;
          }

          &:hover {
            background-color: $color-primary-750 !important;

            td {
              border-color: $color-primary-500;
            }
          }
        }
      }

      tfoot td {
        border-top: 2px solid #dbdbdb;
      }

      td {
        vertical-align: middle;
      }
    }

    .ellipsis {
      span {
        display: block;
        max-width: 100px;
        overflow: hidden;

        text-overflow: ellipsis;
      }
    }

    button {
      padding: 0 10px;
    }
  }

  &__info {
    border-bottom: 2px solid #dbdbdb;
  }

  &__footer {
    display: flex;
    border-top: 2px solid #dbdbdb;

    &--filter {
      margin-left: auto;

      display: flex;
      padding: 20px;

      align-items: center;
      justify-content: center;

      p {
        $recuo: 30px;

        margin-right: $recuo * (-1);

        display: none;
        padding: 5px #{$recuo * 1.5} 5px #{$recuo};
        border-radius: 30px 0 0 30px;
        background: $color-primary;

        font-size: 22px;
        color: $color-light;
        text-align: center;

        pointer-events: none;

        @media (min-width: 768px) {
          display: block;
        }
      }

      i {
        padding: 15px;
        border-radius: 50%;
        background: $color-secondary;
        box-shadow: 2px 2px 5px 0px rgba(#ABABAB, 0.75);

        font-size: 25px;
        color: $color-light;

        transition: all .3s ease-in-out;
        cursor: pointer;

        @media(max-width: 768px){
          font-size: 18px;
        }

        &:hover {
          background: $color-primary;
        }
      }

      &.is-filtered {
        i {
          background: $color-primary;
          color: $color-light;
        }
      }
    }
  }
}

.sticky {
  position: sticky;
  top: 0;
  z-index: 1;

  background-color: #fff;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.pos {
  &-top-right {
    $recuo: -5px;

    top: $recuo;
    right: $recuo;
  }
}
</style>
